import { HttpResponse } from '@angular/common/http';

export class DownloadUtil {

  public static openBlobAsUrl(response: HttpResponse<string> | HttpResponse<Array<string>>) {
    const blob = response.body as unknown as Blob;

    const contentDisposition = response.headers.get('Content-Disposition');
    const filename = contentDisposition?.match(/(?<=filename=)(.+)/)?.[1] || 'export.zip';

    const blobUrl = URL.createObjectURL(blob);

    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = filename;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

}
